import { Fragment, useState, useEffect, useRef } from "react";
// import customerServices from "../../services/customerServices";
import productService from "../../services/productService";
import { clear } from "@testing-library/user-event/dist/clear";


const AccessorySelect = () => {
  //*** Store */
  // const dispatch = useDispatch();
  // const { productItemAllWithChargeStore } = useSelector((state) => state.order);
  // const [selectedProductItem_GUID, setSelectedProductItem_GUID] = useState("");

  const [enteredSearchField, setEnteredSearchField] =
  useState("");
  const [viewList, setViewList] = useState([]);
  const [rowNumber, setRowNumber] = useState(0);

  // (**) customer search field value change
  const handleChangeOfSearchText = (e) => {
    setEnteredSearchField(e.target.value);
    console.log("search entered: " + e.target.value);
  };

  const SelectAccessories = (accessories_GUID)=>{
    console.log("SelectAccessories selected: " + accessories_GUID);
    alert(accessories_GUID);
  }

  useEffect(() => {
    const identifier = setTimeout(async () => {
      console.log("Load Customer search-------");
      let resultSearched = await productService.searchAllAccessoriesWithPrice(
        enteredSearchField
      );
      //  debugger;
      console.log("searched customer ----------> " + resultSearched);
      setRowNumber(0);
      if (resultSearched == null) {
        // setViewList([]);
      } else {
        setViewList(resultSearched);
      }
      console.log("customer list ----------> " + viewList.length);
      // console.log("customerListHtml" + customerListHtml);
    }, 500);

    // (2) clear setTime out
    return () => {
      console.log("clear timeout");
      clearTimeout(identifier);
    };
  }, [enteredSearchField]);


  
  return (
    <Fragment>
      <div style={{ clear: "both" }}></div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card" style={{ marginTop: "10px" }}>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="card-title"
                    style={{ marginBottom: "0px", height: "20px" }}
                  >
                    <div >
                      {" "}
                      <h6>Accessory List</h6>
                    </div>
                    <div >
                    <div class="input-group icons">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-0 pr-2 pr-sm-3" id="basic-addon1"><i class="mdi mdi-magnify"></i></span>
                        </div>
                        <input type="search" class="form-control" 
                          placeholder="Search Accessories" aria-label="Search Accessories"
                          onChange={handleChangeOfSearchText}
                         />
                    </div>
                </div>
                <div style={{clear:'both', marginBottom:'30px'}} ></div>

                    {/* <div className="input-group icons">
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search Customers"
                        aria-label="Search Dashboard"
                        onChange={handleChangeOfSearchText}
                      ></input>
                    </div> */}

                    <div style={{ clear: "both" }}></div>
                    <hr />
                    <div style={{ clear: "both" }}></div>
                  </div>
                  <br /> <br />
                  {/* List Table */}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>SI</th>
                          <th>Name</th> <th>Description</th>
                          <th>Price</th>
                          {/* <th>Is Accesory</th> */}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                      {/* {CodeTracking.showTrackingPosition(
                        "customer 2342343puupoupoiu"
                      )} */}
                      {viewList.map((cus, i) => (
                        <tr key={i}>
                          {/* <th>
                            {" "}
                            <input
                              type="checkbox"
                              id={"custom-checkbox-${cus.customerID_GUID}"}
                              checked={
                                checkedCustomerGUID === cus.customerID_GUID
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                handleOnCheckBoxChange(cus.customerID_GUID)
                              }
                            />
                          </th> */}
                          <th>{i + 1}</th>
                          <td>{cus.name}</td>
                          <td>{cus.description}</td>
                          <td>{cus.chargeAmount}</td>
                          <td>
                            {/* {CodeTracking.showTrackingApi(
                              "orderServices.getOrderVMByCustomerID"
                            )} */}
                            <button
                              onClick={() =>
                                SelectAccessories(
                                  cus.productItemID_GUID
                                )
                              }
                            >
                              <span className="badge badge-danger px-2">
                               {cus.name}
                              </span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AccessorySelect;
